import { TierPracticeFilled, TierProFilled } from '@heidi/design-system/icons';

type UpgradeCtaTierIconProps = {
  isPracticeVariant: boolean;
  className?: string;
};

export function UpgradeCtaTierIcon({
  isPracticeVariant,
  className,
}: UpgradeCtaTierIconProps) {
  if (isPracticeVariant) {
    return <TierPracticeFilled className={className} />;
  }
  return <TierProFilled className={className} />;
}
